import styled from 'styled-components';
const AdjustManyStyled = styled.div`
  height: 100%;
  > div {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .second-wrapper {
    border-radius: 12px;
    background-color: #fff;
    flex: 1;
    .MuiTabs-root {
      height: 54px;
      margin-left: 24px;
      margin-right: 24px;
      border-bottom: 1px solid #f5f5f5;
      .MuiButtonBase-root {
        height: 52px;
        width: 160px;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
  .fab-group {
    padding: 24px 32px;
    display: flex;
    .MuiFab-root {
      height: 36px;
      /* width: 136px; */
      padding: 0 12px;
      color: #fff;
      font-size: 13px;
      border-radius: 24px;
      margin-right: 16px;
      .MuiSvgIcon-root {
        margin-right: 8px;
      }
    }
  }
  .button-group {
    margin-top: 4px;
    background-color: #fff;
    align-items: center;
    border-radius: 12px;
    padding: 24px 32px;
    .exit {
      margin-right: 16px;
    }
  }
`;
export default AdjustManyStyled;
